// TODO@svi: Refactor this component
import { Form, Formik } from "formik";
import {
  FC,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import rightArrow from "../../assets/arrowRightWhite.svg";
import leftArrow from "../../assets/backIcon.svg";
import "./CreatePropopsalWizard.scss";
import {
  EMPTY_STRING,
  MESSAGE_TYPE,
  PROPOSAL_TYPE,
  TERMS_OF_USE_PDF_URL,
} from "../../common/constants/common.constants";
import {
  CreateProposalActiveStep,
  ProposalAction,
  ProposalBuyOption,
  SellProposalOption,
  GoveranceType,
} from "../../common/enums/proposals.enums";
import {
  IBasicProposalData,
  ProposalTypeNew,
} from "../../common/interfaces/proposals.interface";
import {
  createDiscussionProposal,
  createMagicEdenProposal,
  createTransferProposal,
  createTreasuryVaultRelatedProposal,
  createWithdrawalProposal,
} from "../../solana/methods/proposals";
import { createNotification } from "../../utilities/notification";
import FormButtons from "../FormButtons/FormButtons";
import Modal from "../Modal/Modal";

import CreateProposal from "./CreateProposal/CreateProposal";
import ProposalType from "./ProposalType/ProposalType";
import formModel from "./formConfig";
import { validateCreateProposal } from "./validators";
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import { LAMPORTS_PER_SOL, PublicKey, SystemProgram } from "@solana/web3.js";
import CustomCheckbox from "../CustomCheckbox/CustomCheckbox";
import { sleep } from "../../solana/transactions/sendTransactions";
import { getProposalConfigurations } from "../../common/constants/clubs-wizard.constants";
import ErrorNotification from "../ErrorNotification/ErrorNotification";
import { IDetailNftData } from "../../common/interfaces/common.interface";
import { pow } from "mathjs";
import { getTreasuryForClub } from "../../solana/methods/clubs";
import { getSingleWithdrawalAccount } from "../../solana/common/helpers/withdrawal.helpers";
import { getBasicProposalInfo } from "../../solana/common/helpers/proposal-types.helpers";
import { createSolseaProposal } from "../../solana/common/helpers/solsea.helpers";
import {
  createSellPermissionProposal,
  createUpdateApprovalQuorum,
  createUpdateRoleWeightProposal,
} from "../../solana/common/helpers/change-club-config.helpers";
import dayjs from "dayjs";
import { clubsStore } from "../../contexts/clubStore";
import { OverviewClubContext } from "../../contexts/overviewClubContext";
import { BN } from "@project-serum/anchor";
import { ITreasuryTokenAccInfo } from "../../common/interfaces/clubs.interface";

const CreateProposalWizard: FC<{
  closeModal: () => void;
  proposalToBuy?: boolean;
  nftToSell?: IDetailNftData;
}> = ({ closeModal, proposalToBuy, nftToSell }) => {
  const {
    clubBasicInfo,
    treasury,
    membersNfts,
    userRole,
    setTreasury,
    memberRights,
    setWithdrawalMembersInfo,
    withdrawalMembersInfo,
  } = clubsStore();
  const { splProposals, setSplProposals } = useContext(OverviewClubContext);

  const modalRef = useRef<HTMLFormElement>(null);
  const walletContext = useWallet();

  const [agreePlatformFees, toggleAgreePlatformFees] = useState(false);
  const [activeStep, setActiveStep] = useState(
    proposalToBuy || nftToSell
      ? CreateProposalActiveStep.ProposalValues
      : CreateProposalActiveStep.ProposalType
  );

  const wallet = useAnchorWallet();

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.scrollIntoView({ block: "start" });
    }
  }, [modalRef, activeStep]);

  const initialValues = useMemo(
    () =>
      (() => {
        const values = {};
        Object.keys(formModel.formFields).map(
          (key) => (values[key] = formModel.formFields[key].initialValue)
        );
        return values;
      })(),
    []
  );

  const { formId, formFields } = formModel;

  const mapRoleVotes = useMemo(() => {
    return (values: any) => {
      return values.roleVotes.map((rv) => {
        if (rv.updateWeight === EMPTY_STRING) {
          return {
            ...rv,
            updateWeight:
              clubBasicInfo.roleConfig.find((role) => role.name === rv.role)
                ?.roleWeight! / LAMPORTS_PER_SOL,
          };
        } else {
          return { ...rv };
        }
      });
    };
  }, [clubBasicInfo]);

  async function handleSubmit(values, actions) {
    if (values.areAllDisabled) {
      return;
    }
    if (activeStep === CreateProposalActiveStep.ProposalType) {
      setActiveStep((prevValue) => prevValue + 1);
      actions.setSubmitting(false);
    } else if (activeStep === CreateProposalActiveStep.ProposalValues) {
      let createdProposalAddress: PublicKey | undefined;
      try {
        switch (values.proposalType) {
          case ProposalTypeNew.TreasuryVault: {
            createdProposalAddress =
              values.proposalOption === ProposalAction.BuyNft
                ? await getBuyProposalFunction(values)
                : await getSellProposalFunction(values);
            break;
          }
          case ProposalTypeNew.Discussion: {
            createdProposalAddress = await createDiscussionProposal(
              clubBasicInfo.name,
              wallet!,
              values.proposalTitle,
              values.proposalDescription,
              values.link,
              treasury!.treasury,
              clubBasicInfo.type,
              clubBasicInfo.communityMint,
              treasury!.fundraiseCount
            );
            break;
          }
          case ProposalTypeNew.Withdrawal: {
            // Select treasury token account based on selection or mint
            let treasuryToken: ITreasuryTokenAccInfo | undefined = undefined;
            if (values.tokenAddress) {
              treasuryToken = treasury!.tokenAccounts.find(
                (item) => item.tokenAddress?.toString() === values.tokenAddress
              );
            }
            if (!treasuryToken) {
              treasuryToken = treasury!.tokenAccounts.find(
                (item) => item.mint.toString() === values.mint.toString()
              );
            }
            if (!treasuryToken) {
              throw new Error("Can not find token from treasury");
            }
            const { proposalAddress, isZeroQuorum } =
              await createWithdrawalProposal(
                values.proposalTitle,
                values.proposalDescription,
                values.link,
                clubBasicInfo.name,
                wallet!,
                treasury!,
                clubBasicInfo.communityMint,
                clubBasicInfo.type,
                new BN(values.withdrawAmount).mul(
                  new BN(Number(pow(10, treasuryToken.decimals)))
                ),
                treasuryToken
              );
            createdProposalAddress = proposalAddress;

            if (isZeroQuorum) {
              const updatedTreasury = await getTreasuryForClub(
                clubBasicInfo.name
              );
              setTreasury(updatedTreasury);

              const { memberWithdrawalData } = await getSingleWithdrawalAccount(
                clubBasicInfo.name,
                createdProposalAddress,
                treasury!.treasury,
                wallet!,
                values.withdrawAmount * Number(pow(10, treasuryToken.decimals)),
                memberRights,
                treasuryToken.mint,
                treasuryToken.decimals,
                treasuryToken.symbol,
                treasury!.denominatedTokenInfo,
                treasury!.fundraiseCount,
                dayjs().unix(),
                treasury?.reservedRights
              );
              const newWithdrawals = [...withdrawalMembersInfo!];
              newWithdrawals.push(memberWithdrawalData);
              setWithdrawalMembersInfo(newWithdrawals);
            }
            break;
          }
          case ProposalTypeNew.Transfer: {
            // Select treasury token account based on selection or mint
            let treasuryToken: ITreasuryTokenAccInfo | undefined = undefined;
            if (values.tokenAddress) {
              treasuryToken = treasury!.tokenAccounts.find(
                (item) => item.tokenAddress?.toString() === values.tokenAddress
              );
            }
            if (!treasuryToken) {
              treasuryToken = treasury!.tokenAccounts.find(
                (item) => item.mint.toString() === values.mint.toString()
              );
            }
            if (!treasuryToken) {
              throw new Error("Can not find token from treasury");
            }
            const { proposalAddress, isZeroQuorum } =
              await createTransferProposal(
                clubBasicInfo.name,
                clubBasicInfo.type,
                wallet!,
                values.proposalTitle,
                values.proposalDescription,
                values.link,
                values.amountToInvest,
                values.transferAddress,
                treasury!,
                values.mint,
                treasuryToken.tokenAddress,
                treasuryToken.decimals,
                treasury!.fundraiseCount,
                clubBasicInfo.communityMint,
                membersNfts && membersNfts[0]?.metadataAddress,
                membersNfts && membersNfts[0]?.tokenAccount
              );
            createdProposalAddress = proposalAddress;

            if (isZeroQuorum) {
              const updatedTreasury = await getTreasuryForClub(
                clubBasicInfo.name
              );
              setTreasury(updatedTreasury);
            }
            break;
          }
          case ProposalTypeNew.UpdateClubConfig: {
            if (
              values.proposalOption === ProposalAction.UpdateGovernanceConfig
            ) {
              const governanceAccounts =
                values.governanceType.type ===
                GoveranceType.TradeApprovalGovernance
                  ? values.governanceAccounts.filter((acc) => acc.isChecked)
                  : values.governanceAccounts;

              createdProposalAddress = await createUpdateApprovalQuorum(
                clubBasicInfo.name,
                walletContext,
                wallet!,
                clubBasicInfo.type,
                treasury!,
                values.proposalTitle,
                values.proposalDescription,
                values.link,
                treasury!.fundraiseCount,
                clubBasicInfo.communityMint,
                values.newVotingTime,
                governanceAccounts,
                values.newApprovalQuorum,
                new PublicKey(values.governanceType.value)
              );
            } else if (
              values.proposalOption === ProposalAction.UpdateRoleConfig
            ) {
              createdProposalAddress = await createUpdateRoleWeightProposal(
                clubBasicInfo.name,
                wallet!,
                clubBasicInfo.type,
                treasury!,
                values.proposalTitle,
                values.proposalDescription,
                values.link,
                mapRoleVotes(values),
                clubBasicInfo.communityMint,
                treasury!.fundraiseCount
              );
            } else {
              throw new Error("Proposal type not supported");
            }
            break;
          }
          case ProposalTypeNew.AddSellPermission: {
            console.log(values.governanceAccounts);

            const sp = values.governanceAccounts.find(
              (sp) =>
                sp.publickey.toString() === SystemProgram.programId.toString()
            );

            if (!sp) {
              throw new Error(
                "Can't create new trade approval quorum, club already have reached limit of 10!"
              );
            }

            await createSellPermissionProposal(
              sp,
              treasury!,
              values.proposalTitle,
              values.proposalDescription,
              values.link,
              clubBasicInfo.name,
              clubBasicInfo.type,
              clubBasicInfo.communityMint,
              wallet!
            );
          }
        }
        if (createdProposalAddress) {
          await updateCreatedProposal(
            createdProposalAddress,
            splProposals ?? []
          );
        }
        createNotification(
          MESSAGE_TYPE.SUCCESS,
          "Proposal sucessfully created"
        );
        closeModal();
      } catch (error: any) {
        console.log(error);
        createNotification(
          MESSAGE_TYPE.ERROR,
          `Proposal creation failed`,
          error.message
        );
      } finally {
        actions.setSubmitting(false);
      }
      return;
    }
  }

  const getBuyProposalFunction = useCallback(
    async (values) => {
      const treasuryTokenAccountDecimals = treasury!.tokenAccounts.find(
        (item) => item.mint.toString() === values.mint.toString()
      )!.decimals;
      const [offeredAmount, wantedAmount] =
        values.proposalOption === ProposalAction.BuyNft
          ? [values.price * Number(pow(10, treasuryTokenAccountDecimals)), 1]
          : [1, values.price * Number(pow(10, treasuryTokenAccountDecimals))];
      switch (values.buyOption) {
        case ProposalBuyOption.PeerToPeer: {
          return await createTreasuryVaultRelatedProposal(
            values.proposalTitle,
            values.proposalDescription,
            values.link,
            clubBasicInfo.name,
            values.proposalOption,
            offeredAmount,
            wantedAmount,
            wallet!,
            treasury!,
            values.proposalOption === ProposalAction.BuyNft
              ? values.buyOption === ProposalBuyOption.PeerToPeer
                ? new PublicKey(values.nftToBuy)
                : values.existingOffer.nftMint
              : values.nft.mint,
            values.mint,
            values.buyerAddress,
            clubBasicInfo.communityMint,
            clubBasicInfo.type,
            userRole!,
            values.proposalOption === ProposalAction.SellNft &&
              values.nft.tokenAccount,
            treasury!.sellPermissions,
            membersNfts && membersNfts[0].metadataAddress,
            membersNfts && membersNfts[0].tokenAccount,
            false
          );
        }
        case ProposalBuyOption.MagicEden: {
          const nftMintAddress =
            values.proposalOption === ProposalAction.BuyNft
              ? new PublicKey(values.nftToBuy.split("/")[4].split("?")[0])
              : values.nft.mint;

          return await createMagicEdenProposal(
            values.proposalTitle,
            values.proposalDescription,
            clubBasicInfo.name,
            offeredAmount,
            wantedAmount,
            values.proposalOption,
            treasury!,
            userRole!,
            clubBasicInfo.communityMint,
            clubBasicInfo.type!,
            nftMintAddress,
            wallet!,
            values.proposalOption === ProposalAction.SellNft &&
              values.nft.tokenAccount,
            treasury?.sellPermissions!,
            values.link
          );
        }
        case ProposalBuyOption.Solsea: {
          const [wantedAmount, offeredAmount, nftMint] = [
            1,
            values.price * LAMPORTS_PER_SOL,
            new PublicKey(values.nftToBuy.split("/")[4]),
          ];
          return await createSolseaProposal(
            clubBasicInfo.name,
            treasury!,
            wallet!,
            clubBasicInfo.type,
            values.proposalTitle,
            values.proposalDescription,
            values.proposalOption,
            nftMint,
            offeredAmount,
            wantedAmount,
            values.link,
            userRole!,
            values.sellerFeeBps,
            clubBasicInfo.communityMint,
            treasury?.sellPermissions
          );
        }
      }
    },
    [userRole, clubBasicInfo, wallet, treasury]
  );

  const getSellProposalFunction = useCallback(
    async (values) => {
      const treasuryTokenAccountDecimals = treasury!.tokenAccounts.find(
        (item) => item.mint.toString() === values.mint.toString()
      )!.decimals;
      //TODO@all:remove LAMPORTS_PER_SOL
      switch (values.sellOption) {
        case SellProposalOption.PeerToPeer:
          return await createTreasuryVaultRelatedProposal(
            values.proposalTitle,
            values.proposalDescription,
            values.link,
            clubBasicInfo.name,
            values.proposalOption,
            1,
            values.price * Number(pow(10, treasuryTokenAccountDecimals)),
            wallet!,
            treasury!,
            values.nft?.mint ?? nftToSell?.mint,
            values.mint,
            values.buyerAddress,
            clubBasicInfo.communityMint,
            clubBasicInfo.type,
            userRole!,
            values.nft?.tokenAccount ?? nftToSell?.tokenAccount,
            treasury!.sellPermissions,
            membersNfts && membersNfts[0].metadataAddress,
            membersNfts && membersNfts[0].tokenAccount,
            false
          );
        case SellProposalOption.Solsea:
          return await createSolseaProposal(
            clubBasicInfo.name,
            treasury!,
            wallet!,
            clubBasicInfo.type,
            values.proposalTitle,
            values.proposalDescription,
            values.proposalOption,
            values.nft?.mint ?? nftToSell?.mint,
            1,
            values.price * LAMPORTS_PER_SOL,
            values.link,
            userRole!,
            values.sellerFeeBps,
            clubBasicInfo.communityMint,
            treasury?.sellPermissions
          );
      }
    },
    [wallet, treasury, clubBasicInfo, userRole]
  );

  const updateCreatedProposal = async (
    createdProposalAddress: PublicKey,
    loadedSplProposals: IBasicProposalData[],
    counter: number = 1
  ) => {
    if (counter >= 3) {
      throw new Error(
        "Problem with loading proposal data, please refresh the page"
      );
    }
    try {
      const createdProposal = await getBasicProposalInfo(
        createdProposalAddress
      );
      const splProposalsFromContext: IBasicProposalData[] = [
        ...loadedSplProposals,
      ];
      splProposalsFromContext.unshift(createdProposal);
      setSplProposals(splProposalsFromContext);
    } catch (error) {
      console.log(error);
      await sleep(500);
      await updateCreatedProposal(
        createdProposalAddress,
        loadedSplProposals,
        counter + 1
      );
    }
  };

  const renderActiveStep = (activeStep: number) => {
    if (proposalToBuy) {
      return <CreateProposal formFields={formFields} proposalToBuy={true} />;
    }

    if (nftToSell) {
      return <CreateProposal formFields={formFields} nftToSell={nftToSell} />;
    }
    switch (activeStep) {
      case CreateProposalActiveStep.ProposalType:
        return <ProposalType />;
      case CreateProposalActiveStep.ProposalValues:
        return <CreateProposal formFields={formFields} />;
      default:
        return null;
    }
  };

  const isButtonDisabled = useMemo(() => {
    return (isSubmitting: boolean, values: any) =>
      isSubmitting ||
      (values[PROPOSAL_TYPE] === ProposalTypeNew.Withdrawal &&
        !agreePlatformFees &&
        activeStep === CreateProposalActiveStep.ProposalValues) ||
      (treasury !== undefined &&
        userRole !== undefined &&
        getProposalConfigurations(
          treasury,
          clubBasicInfo.type,
          userRole,
          clubBasicInfo.roleConfig
        ).find((item) => !item.disabled) === undefined) ||
      values.magicEdenErrors;
  }, [activeStep, agreePlatformFees, treasury, clubBasicInfo]);

  const showCheckbox = useMemo(() => {
    return (values) =>
      values[PROPOSAL_TYPE] === ProposalTypeNew.Withdrawal &&
      activeStep === CreateProposalActiveStep.ProposalValues;
  }, [activeStep]);

  return (
    <Modal closeModal={closeModal}>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={(values) =>
          validateCreateProposal(values, activeStep, treasury!)
        }
      >
        {({ isSubmitting, values, errors, touched }) => {
          return (
            <Form id={formId} ref={modalRef}>
              <p className="create-proposal-wizard__label">Create proposal</p>
              {renderActiveStep(activeStep)}
              {showCheckbox(values) && (
                <div className="create-proposal__agree-platform-fee">
                  <CustomCheckbox
                    checked={agreePlatformFees}
                    onClickMethod={() => {
                      toggleAgreePlatformFees((prevValue) => !prevValue);
                    }}
                  />
                  <p>
                    I Understand and agree with the{" "}
                    <a
                      href={TERMS_OF_USE_PDF_URL}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Terms & condition
                    </a>{" "}
                    {`${values["isMagicEdenNft"] ? "of Platform fees" : ""}`}
                  </p>
                </div>
              )}
              <ErrorNotification errors={errors} isTouched={touched} />
              <FormButtons
                typeSubmit="submit"
                submitLabel={`${
                  activeStep === CreateProposalActiveStep.ProposalType
                    ? "Next step"
                    : "Create proposal"
                }`}
                submitIcon={rightArrow}
                cancelIcon={leftArrow}
                cancelLabel={`${
                  activeStep === CreateProposalActiveStep.ProposalType ||
                  proposalToBuy ||
                  nftToSell
                    ? "Cancel creation"
                    : "Go back"
                }`}
                submitting={isSubmitting}
                disabled={isButtonDisabled(isSubmitting, values)}
                onCancel={() =>
                  `${
                    activeStep === CreateProposalActiveStep.ProposalType ||
                    proposalToBuy ||
                    nftToSell
                      ? closeModal()
                      : setActiveStep((prevValue) => prevValue - 1)
                  }`
                }
                typeCancel="button"
              />
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default CreateProposalWizard;
